export const OtaPath = {
  CONFIRMATION: '/reservation/confirmation'
}
